import { getResultsByIndex } from "../../../../Algolia/utils/Algolia/utils/get-results-by-index.js";
function getNbHitsByIndex(allSearchResults, indexName) {
  if (!allSearchResults.length || !indexName) {
    return 0;
  }
  const result = getResultsByIndex(allSearchResults, indexName);
  return result?.nbHits ?? 0;
}
export {
  getNbHitsByIndex
};
//# sourceMappingURL=get-hits-by-index.js.map
